import loadHistoryIndex from "@/components/lincMobile/loadHistory/loadHistory.vue";
import loadHistoryDetail from "@/components/lincMobile/loadHistory/loadHistoryDetail.vue";

let routesRequestMuat = [
    {
      path: '',
      meta: {
        title: "Chain System",
      },
      name: "loadHistory",
      component: loadHistoryIndex
    },
    {
      path: 'detail/:id',
      meta: {
        title: "Chain System",
      },
      name: "loadHistory",
      component: loadHistoryDetail
    },
    {
      path: 'edit/:id',
      meta: {
        title: "Chain System",
      },
      name: "loadHistory",
      component: loadHistoryDetail
    },
    
   
]

export default routesRequestMuat
  